import {Creatable} from 'react-select';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import GuestlistRepo from "./GuestlistRepo";

export default class GuestlistCategoryDropdown extends Component {
    constructor(props) {
        super(props);

        this.state = {
            options: []
        };
    }

    refreshMenuOptions() {
        // (non-forced so won't hit network unless needed)
        GuestlistRepo.getCategoryNames()
            .then((optionsList) => {
                let options = [];

                for (let i = 0; i < optionsList.length; i++) {
                    let _option = optionsList[i];

                    options.push({
                        value: _option,
                        label: _option
                    })
                }

                this.setState({
                    options: options
                });
            })
    }

    componentDidMount() {
        this.refreshMenuOptions();
    }

    handleMenuOpen() {
        this.refreshMenuOptions();
    }

    handleSelectedOption(opt) {
        let val = opt.value;

        GuestlistRepo.addCategoryName(val);
        this.refreshMenuOptions();

        this.props.onChange(val);
    }

    handleNewOption(val) {
        GuestlistRepo.addCategoryName(val);
        this.refreshMenuOptions();

        this.props.onChange(val);
    }

    render() {
        return (
            <div className={"GuestlistCategoryDropdown"}>
                {this.props.withIcon &&
                <label htmlFor={this.props.id} className={"RmField__label"}>
                    <i className={"mdi mdi-tag-outline"}/>
                </label>
                }
                <Creatable
                    className={"RmSelectField"}
                    value={this.props.value ? {value: this.props.value, label: this.props.value } : null}
                    onCreateOption={this.handleNewOption.bind(this)}
                    onChange={this.handleSelectedOption.bind(this)}
                    options={this.state.options}
                    placeholder={"Categorie"}
                    onMenuOpen={this.handleMenuOpen.bind(this)}
                    noOptionsMessage={() => "Nog geen categorieën toegevoegd"}
                    id={this.props.id}
                />
            </div>
        );
    }

}

GuestlistCategoryDropdown.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    withIcon: PropTypes.bool,
    id: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/Portal/Guestlist/GuestlistCategoryDropdown.js